export const areasLabel = selectedAreas => {
  switch (selectedAreas.length) {
    case 0:
      return "Choose neighborhoods or boroughs";
    case 1:
      return selectedAreas[0].name;
    default:
      return `${selectedAreas[0].name} +${selectedAreas.length - 1}`;
  }
};
